export function Reducer(form, {field, value}) {
  return {
    ...form, 
    [field]: value
  }
}